import { useState, useEffect } from "react";
import {
  sendMibgas,
  reRunProcess,
  reRunExcel,
} from "../../services/user.service";
import {
  getEmailConfig,
  sendPriceEmail,
  setEmailSendConfig,
} from "../../services/email";
import { toast } from "react-toastify";
import { currentTime, formatDate } from "../../utils/helpers";

const useLastPriceHeader = ({ startDate, refresh }) => {
  // MIBCORRPU-107: este estado solo refleja el envío automático del Excel
  // a OMIP/OmiClear; no debe bloquear el correo principal de LastPrice.
  const [isEmailSet, setIsEmail] = useState(false);
  const [isLoadingSendMib, setIsLoadingSendMib] = useState(false);
  const [isLoadingReRun, setIsLoadingReRun] = useState(false);
  const [isLoadingReRunExcel, setIsLoadingReRunExcel] = useState(false);
  const [isLoadingEmail, setIsLoadingEmail] = useState(false);

  const handleClickSendMib = (mydate) => {
    setIsLoadingSendMib(true);
    toast.info(
      `Envío del WS del día ${formatDate(mydate)} iniciado a las ${currentTime()}.`
    );
    sendMibgas(mydate)
      .then((response) => {
        const time = response.data.time ?? currentTime();
        const msg = `Envío del WS del día ${formatDate(mydate)} finalizado a las ${time}. Estado final: ${response.data.state === "success" ? "éxito" : "error"}.${response?.data?.returnvalue ? "\nRespuesta recibida: " + response?.data?.returnvalue + "." : ""}`;
        response.data.state === "success"
          ? toast.success(msg)
          : toast.error(msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          `Error al enviar a MIBGAS: ${error?.response?.data?.error ?? error.message}`
        );
      })
      .finally(() => {
        setIsLoadingSendMib(false);
      });
  };

  const handleClickReRun = (mydate) => {
    setIsLoadingReRun(true);
    toast.info(
      `Rejecución del día ${formatDate(mydate)} iniciada a las ${currentTime()}.`
    );
    reRunProcess(mydate)
      .then((response) => {
        const time = response.data.time ?? currentTime();
        const msg = `Rejecución del día ${formatDate(mydate)} finalizada a las ${time}. Estado final: ${response.data.state === "success" ? "éxito" : "error"}.${response?.data?.returnvalue ? "\nRespuesta recibida: " + response?.data?.returnvalue + "." : ""}`;
        response.data.state === "success"
          ? toast.success(msg)
          : toast.error(msg);
        refresh(startDate);
      })
      .catch((error) => {
        toast.error(
          `Error en la reejecución: ${error?.response?.data?.error ?? error.message}`
        );
      })
      .finally(() => {
        setIsLoadingReRun(false);
      });
  };

  const handleClickReRunExcel = (mydate) => {
    setIsLoadingReRunExcel(true);
    toast.info(
      `Envío del Excel a OMIP y OmiClear del día ${formatDate(mydate)} iniciado a las ${currentTime()}.`
    );
    reRunExcel(mydate)
      .then((response) => {
        const time = response.data.time ?? currentTime();
        const msg = `Envío del Excel a OMIP y OmiClear día ${formatDate(mydate)} finalizado a las ${time}. Estado final: ${response.data.state === "success" ? "éxito" : "error"}.${response?.data?.returnvalue ? "\nRespuesta recibida: " + response?.data?.returnvalue + "." : ""}`;
        response.data.state === "success"
          ? toast.success(msg)
          : toast.error(msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          `Error al enviar Excel a OMIP/OmiClear: ${error?.response?.data?.error ?? error.message}`
        );
      })
      .finally(() => {
        setIsLoadingReRunExcel(false);
      });
  };

  const fetchEmailSettings = async () => {
    try {
      const response = await getEmailConfig();
      if (response.status !== 200) {
        throw new Error("Error fetching email settings");
      }
      setIsEmail(response.data.sendEmail);
    } catch (error) {
      console.error("Error fetching email settings:", error);
    }
  };

  const handleSetEmailConfig = async (event) => {
    try {
      const payload = { sendEmail: event.target.checked };
      const response = await setEmailSendConfig(payload);
      if (response.status !== 200) {
        toast.error("Error al guardar la configuración");
        throw new Error("Error setting email config");
      }
      setIsEmail(response.data.config.sendEmail);
      toast.success("Configuración de email guardada");
    } catch (error) {
      console.error("Error setting email config:", error);
    }
  };

  const handleSendPricesEmail = async (date) => {
    setIsLoadingEmail(true);
    try {
      const response = await sendPriceEmail(date);
      if (response.status !== 200) {
        toast.error("Error al enviar el email de precios");
        throw new Error("Error sending price email");
      }
      toast.success("Email de precios enviado correctamente");
    } catch (error) {
      console.error("Error sending price email:", error);
    } finally {
      setIsLoadingEmail(false);
    }
  };

  useEffect(() => {
    fetchEmailSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isEmailSet,
    isLoadingSendMib,
    isLoadingReRun,
    isLoadingReRunExcel,
    isLoadingEmail,
    handleClickSendMib,
    handleClickReRun,
    handleClickReRunExcel,
    handleSetEmailConfig,
    handleSendPricesEmail,
  };
};

export default useLastPriceHeader;
